export function Footer() {
  return (
    <div className={'footer d-flex fixed-bottom align-items-center shadow-lg'}>
      <div className={'container-fluid text-end me-4 ms-4'}>
        <p className={'text-basic'}>
          <a
            className={'text-basic'}
            href={'https://www.padam-mobility.com/en/'}
            target="_blank"
            rel="noreferrer">
            2026 © Padam Mobility
          </a>
        </p>
      </div>
    </div>
  );
}
